import { EngineReportCylinderUnit } from '@navstation-portal/reporting/data-model/engine-report';
import { injectDispatch } from '@ngrx/signals/events';
import { engineReportEvents } from '../../engine-report-events';

export type CylinderUnitFieldChangeHandler = <K extends keyof EngineReportCylinderUnit>(
  index: number,
  field: K,
  value: EngineReportCylinderUnit[K]
) => void;

/**
 * Must be called from an injection context (e.g. a component field initializer),
 * same as `injectDispatch` itself.
 */
export function injectCylinderUnitFieldChangeHandler(): CylinderUnitFieldChangeHandler {
  const dispatch = injectDispatch(engineReportEvents);

  return <K extends keyof EngineReportCylinderUnit>(
    index: number,
    field: K,
    value: EngineReportCylinderUnit[K]
  ): void => {
    dispatch.updateCylinderUnit({ index, changes: { [field]: value } as Partial<EngineReportCylinderUnit> });
  };
}
